export default __webpack_public_path__ + "static/media/070.2242ad06.jpg";